/**
 * Replacement for next/image - simple img tag with lazy loading
 */

import { ImgHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface OptimizedImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  fill?: boolean;
  priority?: boolean;
}

export function OptimizedImage({
  src,
  alt,
  width,
  height,
  fill,
  priority,
  className,
  ...props
}: OptimizedImageProps) {
  return (
    <img
      src={src as string}
      alt={alt || ''}
      width={fill ? undefined : width}
      height={fill ? undefined : height}
      loading={priority ? 'eager' : 'lazy'}
      className={cn(
        fill && 'absolute inset-0 w-full h-full object-cover',
        className
      )}
      {...props}
    />
  );
}

// Default export for easier replacement of next/image
export default OptimizedImage;
